import { BRAND, isMarketGB } from 'src/constants/main';
import { VehiclePriceDetailsBlockStyled } from './VehiclePriceDetailsBlockStyled';
import { SC } from 'src/styles/theme';
import React from 'react';
import { VehiclePriceDetailsBlockStyledAC } from './AC/VehiclePriceDetailsBlockStyledAC';
import { VehiclePriceDetailsBlockStyledAP } from './AP/VehiclePriceDetailsBlockStyledAP';
import { VehiclePriceDetailsBlockStyledDS } from './DS/VehiclePriceDetailsBlockStyledDS';
import { VehiclePriceDetailsBlockStyledOV } from './OV/VehiclePriceDetailsBlockStyledOV';
import { VehiclePriceDetailsBlockStyledOVGB } from './OV/VehiclePriceDetailsBlockStyledOVGB';

export interface VehiclePriceDetailsBlockProps extends SC {}

export const VehiclePriceDetailsBlock = (props: VehiclePriceDetailsBlockProps) => {
    if (BRAND === 'AC') return <VehiclePriceDetailsBlockStyledAC {...props} />;
    if (BRAND === 'AP') return <VehiclePriceDetailsBlockStyledAP {...props} />;
    if (BRAND === 'DS') return <VehiclePriceDetailsBlockStyledDS {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? (
            <VehiclePriceDetailsBlockStyledOVGB {...props} />
        ) : (
            <VehiclePriceDetailsBlockStyledOV {...props} />
        );
    return <VehiclePriceDetailsBlockStyled {...props} />;
};

export default VehiclePriceDetailsBlock;
